interface LivingBackgroundProps {
    className?: string;
}

/**
 * Reserved background layer for app-wide visual effects.
 * Intentionally neutral with no gradients.
 */
export const LivingBackground = ({ className = "" }: LivingBackgroundProps) => {
    return <div className={`fixed inset-0 pointer-events-none ${className}`} style={{ zIndex: 0 }} aria-hidden="true" />;
};

export default LivingBackground;



